import React, { FC, Fragment } from 'react';

interface StepTrackerProps {
  current: number;
  labels: string[];
}

function labelColorClass(active: boolean, done: boolean): string {
  if (active) return 'text-brand';
  if (done) return 'text-brand-mid';
  return 'text-slate-400';
}

const StepTracker: FC<StepTrackerProps> = ({ current, labels }) => (
  <div className="portal-step-tracker hidden md:block bg-white border-b border-slate-200 px-4 py-2 flex-shrink-0">
    <div className="max-w-4xl mx-auto flex items-center sm:items-start w-full">
      {labels.map((stepLabel, i) => {
        const done = i < current;
        const active = i === current;
        const stepNumber = i + 1;
        const connectorDone = i > 0 && (i - 1) < current;

        return (
          <Fragment key={stepLabel}>
            {i > 0 && (
              <div
                className={`flex-1 h-0.5 mx-1 sm:mx-2 mt-0 sm:mt-3 rounded ${
                  connectorDone ? 'bg-brand' : 'bg-slate-200'
                }`}
              />
            )}
            <div className="flex flex-col items-center flex-shrink-0">
              <div
                className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${
                  done || active ? 'bg-brand text-white' : 'bg-slate-200 text-slate-400'
                } ${active ? 'ring ring-blue-100' : ''}`}
              >
                {done ? '✓' : stepNumber}
              </div>
              <span
                className={`mt-0.5 font-medium hidden sm:block whitespace-nowrap text-step-label ${labelColorClass(active, done)}`}
              >
                {stepLabel}
              </span>
            </div>
          </Fragment>
        );
      })}
    </div>
  </div>
);

export default StepTracker;
